import React from "react";
import ReactDOM from "react-dom/client";
import AppRoutes from "./AppRoutes";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.min.css";
import { ControlProvider } from "./context/ControlContext";
import { InvoiceProvider } from "./context/InvoiceContext";
import { PagSeguroProvider } from "./context/PagSeguroContext";
import ErrorBoundary from "./ErrorBoundary";
import { 
  checkBrowserCompatibility, 
  checkDOMElements, 
  logBrowserInfo, 
  handleCriticalError 
} from "./utils/browserCheck";

// Log das informações do navegador para debug
logBrowserInfo();

// Verificação de compatibilidade do navegador
const compatibilityErrors = checkBrowserCompatibility();
if (compatibilityErrors.length > 0) {
  console.warn('⚠️ Problemas de compatibilidade detectados:', compatibilityErrors);
  handleCriticalError(new Error('Navegador incompatível'), compatibilityErrors.join(', '));
} else {
  // Verificação de elementos DOM
  const domErrors = checkDOMElements();
  if (domErrors.length > 0) {
    console.error('❌ Problemas de DOM:', domErrors);
    handleCriticalError(new Error('Problemas de DOM'), domErrors.join(', '));
  } else {
    try {
      const rootElement = document.getElementById("root");
      const root = ReactDOM.createRoot(rootElement);
      
      root.render(
        <React.StrictMode>
          <ErrorBoundary>
            <ControlProvider>
              <PagSeguroProvider>
                <InvoiceProvider>
                  <AppRoutes />
                </InvoiceProvider>
              </PagSeguroProvider>
            </ControlProvider>
          </ErrorBoundary>
        </React.StrictMode>,
      );
      
      console.log('✅ Aplicação iniciada com sucesso');
      
    } catch (error) {
      console.error('❌ Erro ao renderizar a aplicação:', error);
      handleCriticalError(error, 'Falha na renderização inicial');
    }
  }
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
